var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInventoryApprovedProductsCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.24 17.5805H30.84L27.46 14.2005C27.19 13.9305 26.75 13.9305 26.47 14.2005C26.2 14.4705 26.2 14.9105 26.47 15.1905L28.86 17.5805H19.14L21.53 15.1905C21.8 14.9205 21.8 14.4805 21.53 14.2005C21.26 13.9305 20.82 13.9305 20.54 14.2005L17.17 17.5805H16.77C15.87 17.5805 14 17.5805 14 20.1405C14 21.1105 14.2 21.7505 14.62 22.1705C14.86 22.4205 15.15 22.5505 15.46 22.6205C15.75 22.6905 16.06 22.7005 16.36 22.7005H31.64C31.95 22.7005 32.24 22.6805 32.52 22.6205C33.36 22.4205 34 21.8205 34 20.1405C34 17.5805 32.13 17.5805 31.24 17.5805Z",
    fill: "#12B76A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.09 24H16.91C16.29 24 15.82 24.55 15.92 25.16L16.76 30.3C17.04 32.02 17.79 34 21.12 34H26.73C30.1 34 30.7 32.31 31.06 30.42L32.07 25.19C32.19 24.57 31.72 24 31.09 24ZM26.88 28.05L23.63 31.05C23.49 31.18 23.31 31.25 23.12 31.25C22.93 31.25 22.74 31.18 22.59 31.03L21.09 29.53C20.8 29.24 20.8 28.76 21.09 28.47C21.39 28.18 21.86 28.18 22.16 28.47L23.15 29.46L25.87 26.95C26.17 26.67 26.65 26.69 26.93 26.99C27.21 27.3 27.19 27.77 26.88 28.05Z",
    fill: "#12B76A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventoryApprovedProductsCardIcon);
export default __webpack_public_path__ + "static/media/inventory-approved-products-card-icon.91b79542a23679c047a5dceac87aae11.svg";
export { ForwardRef as ReactComponent };